const THREE = require("three");
const config = require("../config.js");
const UTILS = require("./utils.js");
var vO129 = {};
module.exports.getColor = (p5511, p5512) => {
  var v4685 = p5511 + "-" + (p5512 || "");
  var v4686 = vO129[v4685];
  if (!v4686) {
    v4686 = new THREE.Color(p5511);
    if (p5512) {
      v4686.multiplyScalar(p5512);
    }
    var vO130 = {};
    v4686.getHSL(vO130);
    vO130.s = Math.min(1, vO130.s * 1.5);
    v4686.setHSL(vO130.h, vO130.s, vO130.l);
    vO129[v4685] = v4686;
  }
  return v4686;
};
module.exports.checkColor = p5513 => {
  if (!p5513 || !p5513.attributes) {
    return false;
  }
  if (!p5513.attributes || !p5513.attributes.color) {
    for (var v4687 = (p5513.attributes && p5513.attributes.position ? p5513.attributes.position.count : 0) * 3, v4688 = new Float32Array(v4687), vLN0730 = 0; vLN0730 < v4687; vLN0730++) {
      v4688[vLN0730] = 1;
    }
    p5513.setAttribute("color", new THREE.BufferAttribute(v4688, 3));
  }
  return true;
};
module.exports.bufferCheck = p5514 => {
  if (!p5514.attributes || !p5514.attributes.color) {
    p5514.setAttribute("color", new THREE.BufferAttribute(new Float32Array(0), 3));
  }
  if (!p5514.attributes || !p5514.attributes.uv) {
    p5514.setAttribute("uv", new THREE.BufferAttribute(new Float32Array(0), 2));
  }
  if (!p5514.attributes || !p5514.attributes.normal) {
    p5514.setAttribute("normal", new THREE.BufferAttribute(new Float32Array(0), 3));
  }
  if (!p5514.attributes || !p5514.attributes.position) {
    p5514.setAttribute("position", new THREE.BufferAttribute(new Float32Array(0), 3));
  }
};
module.exports.colorize = (p5515, p5516, p5517) => {
  if (p5515 && (p5516 = p5517 || module.exports.getColor(p5516), !!module.exports.checkColor(p5515))) {
    for (var v4689 = p5515.getAttribute("color"), vLN0731 = 0; vLN0731 < v4689.count; vLN0731++) {
      v4689.setXYZ(vLN0731, p5516.r, p5516.g, p5516.b);
    }
  }
};
var v4690;
var vF23 = (p5518, p5519, p5520, p5521) => {
  for (var v4691 = p5518.getAttribute("uv"), vLN0732 = 0; vLN0732 < v4691.count; vLN0732++) {
    var v4692 = v4691.getX(vLN0732) * p5519 * (p5521 || 1);
    var v4693 = v4691.getY(vLN0732) * p5520 * (p5521 || 1);
    v4692 = 0.5 + v4692 - p5519 * (p5521 || 1) / 2;
    v4691.setXY(vLN0732, v4692, v4693);
  }
  p5518.attributes.uv.needsUpdate = true;
};
var vF24 = (p5522, p5523, p5524, p5525, p5526, p5527) => p5522 >= p5524 - p5526 && p5522 <= p5524 + p5526 && p5523 >= p5525 - p5527 && p5523 <= p5525 + p5527;
var vF25 = (p5528, p5529) => {
  if (module.exports.checkColor(p5528)) {
    var v4694 = p5528.getIndex();
    var v4695 = p5528.getAttribute("color");
    if (v4694 && v4695) {
      var v4696 = v4694.array;
      for (var v4697 = Math.min(v4696.length, 6), vLN0733 = 0; vLN0733 < v4697; vLN0733 += 3) {
        v4695.setXYZ(v4696[vLN0733], p5529[vLN0733 / 3][0].r, p5529[vLN0733 / 3][0].g, p5529[vLN0733 / 3][0].b);
        v4695.setXYZ(v4696[vLN0733 + 1], p5529[vLN0733 / 3][1].r, p5529[vLN0733 / 3][1].g, p5529[vLN0733 / 3][1].b);
        v4695.setXYZ(v4696[vLN0733 + 2], p5529[vLN0733 / 3][2].r, p5529[vLN0733 / 3][2].g, p5529[vLN0733 / 3][2].b);
      }
      p5528.attributes.color.needsUpdate = true;
    }
  }
};
var vA255 = [];
var vA256 = ["a", "b", "c", "d"];
module.exports.generatePlane = (p5530, p5531, p5532, p5533, p5534, p5535) => {
  p5530 *= p5532.ratio || 1;
  var v4698 = (p5532.scale ? p5530 + "_" + p5531 + "_" : "") + (p5532.scale || "s") + (p5532.tilesX || "x") + (p5532.tilesZ || "z") + (p5532.noise ? p5533 + "_" + p5534 + "_" + p5535 : "n") + (p5532.colr == null ? "c" : p5532.colr) + (p5532.darken || "d") + (p5532.wSpeed || "wS") + (p5532.wHeight || "wH") + (p5532.scaleM || "sm");
  v4690 = vA255[v4698];
  if (!v4690) {
    var v4699 = p5532.tilesX || 1;
    var v4700 = p5532.tilesZ || 1;
    var v4701 = p5532.scaleM || p5532.scale;
    v4690 = new THREE.PlaneGeometry(1, 1, v4699, v4700);
    if (p5532.noise) {
      var vO131 = {};
      var v4702 = p5532.margin || 0;
      if (v4690.attributes && v4690.attributes.position) {
        for (var v4703 = v4690.getAttribute("position"), vLN0736 = 0; vLN0736 < v4703.count; vLN0736++) {
          var v4704 = v4703.getX(vLN0736);
          var v4705 = v4703.getY(vLN0736);
          if (!p5532.pinEdges || v4704 != -0.5 && v4704 != 0.5 && v4705 != -0.5 && v4705 != 0.5) {
            if (p5532.objects) {
              for (var vLN0735 = 0; vLN0735 < p5532.objects.length; ++vLN0735) {
                if (p5532.objects[vLN0735].y - p5532.objects[vLN0735].height <= p5534 + 0.1 && p5532.objects[vLN0735].y + p5532.objects[vLN0735].height > p5534 + p5532.noise && vF24(p5535 + -v4705 * p5530, p5533 + v4704 * p5531, p5532.objects[vLN0735].z, p5532.objects[vLN0735].x, p5532.objects[vLN0735].length + v4702, p5532.objects[vLN0735].width + v4702)) {
                  v4703.setZ(vLN0736, Math.random() * p5532.noise + 1);
                  vO131[vLN0736] = module.exports.getColor(p5532.colr, 0.6);
                  break;
                }
              }
            } else {
              v4703.setZ(vLN0736, Math.random() * p5532.noise);
            }
          }
          if (!vO131[vLN0736]) {
            vO131[vLN0736] = module.exports.getColor(p5532.colr);
          }
        }
        v4690.attributes.position.needsUpdate = true;
      }
      module.exports.checkColor(v4690);
      if (v4690.attributes && v4690.attributes.color) {
        var v4706;
        for (var v4707 = v4690.getAttribute("color"), vLN0736 = 0; vLN0736 < v4707.count; vLN0736++) {
          v4706 = vO131[vLN0736];
          v4707.setXYZ(vLN0736, v4706.r, v4706.g, v4706.b);
        }
        v4690.attributes.color.needsUpdate = true;
      }
    } else {
      module.exports.colorize(v4690, null, module.exports.getColor(p5532.colr || "#ffffff", p5532.darken || 1));
    }
    if (v4701) {
      vF23(v4690, p5531 / config.worldUV, p5530 / config.worldUV, v4701);
    }
    v4690.computeVertexNormals();
    vA255[v4698] = v4690;
  }
  return v4690;
};
var vA257 = [];
module.exports.generateCube = (p5536, p5537, p5538, p5539, p5540) => {
  p5536 = p5536 || [1, 1, 1, 1, 1, 1];
  p5540.flipp = (p5537 > p5538 || p5539 > p5538) && p5540.src == "floor_0";
  p5540.flippW = p5537 > p5539 && p5540.src == "floor_0";
  var v4708 = (p5540.scale ? p5537 + "_" + p5538 + "_" + p5539 + "_" : "") + (p5540.colr == null ? "" : p5540.colr) + (p5540.scale || "") + (p5540.flippW ? "flw" : "fnw") + (p5540.flipp ? "fl" : "fn") + (p5540.useScale || "") + (p5540.noAmb || "na") + (p5540.scaleM || "sm") + (p5540.darken ? "d_" + p5540.darken : "");
  for (var vLN0737 = 0; vLN0737 < p5536.length; ++vLN0737) {
    v4708 += "_" + p5536[vLN0737];
  }
  v4714 = vA257[v4708];
  if (!v4714) {
    p5540.colr = p5540.colr == null ? "#ffffff" : p5540.colr;
    var v4709 = false;
    if (!p5540.noAmb) {
      v4709 = true;
    }
    var v4710;
    var v4711;
    if (v4709) {
      v4710 = module.exports.getColor(p5540.colr, p5540.darken || 1);
      v4711 = p5540.amb ? module.exports.getColor(p5540.colr, (p5540.darken || 1) * 0.7) : v4710;
    }
    var v4712;
    var vA258 = [];
    var v4713 = p5540.scaleM || p5540.scale;
    if (p5536[0]) {
      v4712 = new THREE.PlaneGeometry(1, 1, 1, 1);
      v4712.rotateY(Math.PI / 2);
      if (p5540.flipp) {
        v4712.rotateX(Math.PI / 2);
      }
      v4712.translate(0.5, 0.5, 0);
      if (v4709) {
        vF25(v4712, [[v4710, v4711, v4710], [v4711, v4711, v4710]]);
      }
      if (v4713) {
        vF23(v4712, (p5540.flipp ? p5538 : p5539) / config.worldUV, (p5540.flipp ? p5539 : p5538) / config.worldUV, v4713);
      }
      vA258.push(v4712);
    }
    if (p5536[1]) {
      v4712 = new THREE.PlaneGeometry(1, 1, 1, 1);
      v4712.rotateY(-Math.PI / 2);
      if (p5540.flipp) {
        v4712.rotateX(Math.PI / 2);
      }
      v4712.translate(-0.5, 0.5, 0);
      if (v4709) {
        vF25(v4712, [[v4710, v4711, v4710], [v4711, v4711, v4710]]);
      }
      if (v4713) {
        vF23(v4712, (p5540.flipp ? p5538 : p5539) / config.worldUV, (p5540.flipp ? p5539 : p5538) / config.worldUV, v4713);
      }
      vA258.push(v4712);
    }
    if (p5536[2]) {
      v4712 = new THREE.PlaneGeometry(1, 1, 1, 1);
      v4712.rotateX(-Math.PI / 2);
      if (p5540.flippW) {
        v4712.rotateY(Math.PI / 2);
      }
      v4712.translate(0, 1, 0);
      if (v4709) {
        vF25(v4712, [[v4710, v4710, v4710], [v4710, v4710, v4710]]);
      }
      if (v4713) {
        vF23(v4712, (p5540.flippW ? p5539 : p5537) / config.worldUV, (p5540.flippW ? p5537 : p5539) / config.worldUV, v4713);
      }
      vA258.push(v4712);
    }
    if (p5536[3]) {
      v4712 = new THREE.PlaneGeometry(1, 1, 1, 1);
      v4712.rotateX(Math.PI / 2);
      if (p5540.flippW) {
        v4712.rotateY(Math.PI / 2);
      }
      v4712.translate(0, 0, 0);
      if (v4709) {
        vF25(v4712, [[v4711, v4711, v4711], [v4711, v4711, v4711]]);
      }
      if (v4713) {
        vF23(v4712, (p5540.flippW ? p5539 : p5537) / config.worldUV, (p5540.flippW ? p5537 : p5539) / config.worldUV, v4713);
      }
      vA258.push(v4712);
    }
    if (p5536[4]) {
      v4712 = new THREE.PlaneGeometry(1, 1, 1, 1);
      if (p5540.flipp) {
        v4712.rotateZ(Math.PI / 2);
      }
      v4712.translate(0, 0.5, 0.5);
      if (v4709) {
        vF25(v4712, [[v4710, v4711, v4710], [v4711, v4711, v4710]]);
      }
      if (v4713) {
        vF23(v4712, (p5540.flipp ? p5538 : p5537) / config.worldUV, (p5540.flipp ? p5537 : p5538) / config.worldUV, v4713);
      }
      vA258.push(v4712);
    }
    if (p5536[5]) {
      v4712 = new THREE.PlaneGeometry(1, 1, 1, 1);
      v4712.rotateY(Math.PI);
      if (p5540.flipp) {
        v4712.rotateZ(Math.PI / 2);
      }
      v4712.translate(0, 0.5, -0.5);
      if (v4709) {
        vF25(v4712, [[v4710, v4711, v4710], [v4711, v4711, v4710]]);
      }
      if (v4713) {
        vF23(v4712, (p5540.flipp ? p5538 : p5537) / config.worldUV, (p5540.flipp ? p5537 : p5538) / config.worldUV, v4713);
      }
      vA258.push(v4712);
    }
    if (vA258.length) {
      var v4714 = module.exports.mergeGeometries(vA258);
    }
    if (!v4714) {
      return new THREE.BufferGeometry();
    }
    if (p5540 && p5540.useScale) {
      v4714.scale(p5537, p5538, p5539);
      v4714.translate(0, -p5538 / 2, 0);
    }
    if (!v4709) {
      module.exports.colorize(v4714, null, module.exports.getColor(p5540.colr));
    }
    vA257[v4708] = v4714;
  }
  return v4714;
};
var vA259 = [];
module.exports.generateCone = (p5541, p5542) => {
  var v4715 = (p5542.useScale || "u") + (p5542.closC || "c") + (p5542.sides || "s") + (p5542.colr == null ? "co" : p5542.colr) + (p5542.darken || "d") + (p5542.vNoise || "v") + (p5542.thetaL || "thl");
  v4690 = vA259[v4715];
  if (!v4690) {
    p5542.thetaL = p5542.thetaL == null ? 360 : p5542.thetaL;
    p5542.thetaL = THREE.MathUtils.degToRad(p5542.thetaL);
    v4690 = new THREE.ConeGeometry(1, 1, p5542.sides || 12, 1, !p5542.closC, Math.PI / 4, p5542.thetaL);
    if (p5542 && !p5542.useScale) {
      v4690.translate(0, 0.5, 0);
    }
    if (p5542 && p5542.vNoise && v4690.attributes && v4690.attributes.position) {
      var v4716;
      for (var v4717 = v4690.getAttribute("position"), vLN0738 = 0; vLN0738 < v4717.count; vLN0738++) {
        v4716 = Math.random() * p5542.vNoise;
        v4717.setXYZ(vLN0738, v4716, v4716, v4716);
      }
      v4690.attributes.position.needsUpdate = true;
    }
    module.exports.colorize(v4690, null, module.exports.getColor(p5542.colr || "#ffffff", p5542.darken || 1));
    vA259[v4715] = v4690;
  }
  return v4690;
};
var vA260 = [];
module.exports.generateSphere = (p5543, p5544, p5545, p5546) => {
  var v4718 = (p5546.scale ? p5543 + "_" + p5544 + "_" + p5545 + "_" : "") + (p5546.colr == null ? "c" : p5546.colr) + (p5546.scale || "s") + (p5546.useScale || "u") + (p5546.vNoise || "v") + (p5546.coat || "o");
  v4690 = vA260[v4718];
  if (!v4690) {
    p5546.colr = p5546.colr == null ? "#ffffff" : p5546.colr;
    v4690 = new THREE.SphereGeometry(1, 12, 8);
    if (p5546 && p5546.vNoise && v4690.attributes && v4690.attributes.position) {
      var v4719;
      for (var v4720 = v4690.getAttribute("position"), vLN0739 = 0; vLN0739 < v4720.count; vLN0739++) {
        v4719 = Math.random() * p5546.vNoise;
        v4720.setXYZ(vLN0739, v4719, v4719, v4719);
      }
      v4690.attributes.position.needsUpdate = true;
    }
    if (p5546 && p5546.useScale) {
      v4690.scale(p5543 / 2, p5544 / 2, p5545 / 2);
    }
    module.exports.colorize(v4690, null, module.exports.getColor(p5546.colr || "#ffffff", p5546.darken || 1));
    vA260[v4718] = v4690;
  }
  return v4690;
};
var vA261 = [];
module.exports.generateCylinder = (p5547, p5548, p5549, p5550) => {
  var v4721 = (p5550.colr == null ? "c" : p5550.colr) + (p5550.useScale || "u") + (p5550.sides || "s") + (p5550.open || "o") + (p5550.vNoise || "v") + (p5550.rTop || "rt") + (p5550.rBot || "rb") + (p5550.thetaS || "ts") + (p5550.thetaL || "tl") + (p5550.scaleM || "sm") + (p5550.scale || "s");
  v4690 = vA261[v4721];
  if (!v4690) {
    p5550.colr = p5550.colr == null ? "#ffffff" : p5550.colr;
    p5550.rTop = p5550.rTop == null ? 1 : p5550.rTop;
    p5550.thetaS = p5550.thetaS == null ? 0 : p5550.thetaS;
    p5550.thetaS = THREE.MathUtils.degToRad(p5550.thetaS);
    p5550.thetaL = p5550.thetaL == null ? 360 : p5550.thetaL;
    p5550.thetaL = THREE.MathUtils.degToRad(p5550.thetaL);
    v4690 = new THREE.CylinderGeometry(p5550.rTop, p5550.rBot, 1, p5550.sides || 12, 1, p5550.open || false, p5550.thetaS, p5550.thetaL);
    var v4722 = p5550.scaleM || p5550.scale;
    if (v4722) {
      vF23(v4690, p5549 / config.worldUV, p5548 / config.worldUV, v4722);
    }
    if (p5550 && p5550.vNoise && v4690.attributes && v4690.attributes.position) {
      var v4723;
      for (var v4724 = v4690.getAttribute("position"), vLN0740 = 0; vLN0740 < v4724.count; vLN0740++) {
        v4723 = Math.random() * p5550.vNoise;
        v4724.setXYZ(vLN0740, v4723, v4723, v4723);
      }
      v4690.attributes.position.needsUpdate = true;
    }
    if (p5550 && !p5550.useScale) {
      v4690.translate(0, 0.5, 0);
    }
    module.exports.colorize(v4690, null, module.exports.getColor(p5550.colr || "#ffffff", 1));
    vA261[v4721] = v4690;
  }
  return v4690;
};
var v4725 = new THREE.Vector2(0, 0);
var v4726 = new THREE.Vector2(1 / 6, 1);
var v4727 = new THREE.Vector2(1 / 6 * 5, 1);
var v4728 = new THREE.Vector2(1, 0);
class C235 extends THREE.ExtrudeGeometry {
  constructor() {
    super(new THREE.Shape([v4725, v4726, v4727, v4728]), {
      depth: 1,
      bevelEnabled: false
    });
  }
}
var v4729 = new THREE.Vector2(0, 0);
var v4730 = new THREE.Vector2(0, 1);
var v4731 = new THREE.Vector2(1, 0);
class C236 extends THREE.ExtrudeGeometry {
  constructor() {
    super(new THREE.Shape([v4729, v4730, v4731]), {
      depth: 1,
      bevelEnabled: false
    });
  }
}
var vA262 = [];
module.exports.generateRamps = (p5551, p5552, p5553, p5554) => {
  var v4732 = (p5554.scale ? p5551 + "_" + p5553 + "_" : "") + (p5554.scale || "s") + (p5554.colr == null ? "c" : p5554.colr) + (p5554.scaleM || "sm");
  v4690 = vA262[v4732];
  if (!v4690) {
    var v4733 = p5554.scaleM || p5554.scale;
    p5554.colr = p5554.colr == null ? "#ffffff" : p5554.colr;
    v4690 = new C236();
    v4690.translate(-0.5, -0.5, -0.5);
    module.exports.colorize(v4690, null, module.exports.getColor(p5554.colr || "#ffffff", 1));
    if (v4733) {
      vF23(v4690, p5553 / config.worldUV, p5551 / config.worldUV, v4733);
    }
    vA262[v4732] = v4690;
  }
  return v4690;
};
module.exports.reset = () => {
  vO129 = [];
  vA255 = [];
  vA257 = [];
  vA259 = [];
  vA260 = [];
  vA261 = [];
  vA262 = [];
};
module.exports.fixBufferGeometry = p5555 => {
  module.exports.checkColor(p5555);
  module.exports.bufferCheck(p5555);
};
module.exports.mergeGeometries = p5556 => {
  for (var vLN0741 = 0; vLN0741 < p5556.length; vLN0741++) {
    if (p5556[vLN0741] != null && p5556[vLN0741].index != null) {
      p5556[vLN0741] = p5556[vLN0741].toNonIndexed();
    }
    module.exports.fixBufferGeometry(p5556[vLN0741]);
  }
  return THREE.BufferGeometryUtils.mergeGeometries(p5556);
};